import { render, staticRenderFns } from "./Complaint2.vue?vue&type=template&id=c0a478ba&scoped=true"
import script from "./Complaint2.vue?vue&type=script&lang=js"
export * from "./Complaint2.vue?vue&type=script&lang=js"
import style0 from "./Complaint2.vue?vue&type=style&index=0&id=c0a478ba&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a478ba",
  null
  
)

export default component.exports